import api, { APIURL, errorHandle } from '../api/api'

class RegisterUser {
    constructor(data) {
        this.title = data.title
        this.firstName = data.first_name
        this.lastName = data.last_name
        this.idCard = data.id_card
        this.username = data.id_card
        this.password = data.password
        this.position = data.position
        this.level = data.level
        this.office = data.office
        this.tel = data.tel
        this.email = data.email
    }

    serialized() {
        const idCardText = this.idCard?.replace(/ +/g, '')
        const telText = this.tel?.replace(/ +/g, '')
        return {
            "title": this.title?.value,
            "first_name": this.firstName,
            "last_name": this.lastName,
            "id_card": idCardText,
            "username": idCardText,
            "password": this.password,
            "position": this.position,
            "level_id": parseInt(this.level.value),
            "office_code": this.office?.value,
            "tel": telText,
            "email": this.email
        }
    }

}

export const postRegister = (data) => {
    return new Promise((resolve, reject) => {
        api.post(APIURL.REGISTER, data)
            .then(response => {
                if (response.data.data) {
                    resolve(response.data.data)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export default RegisterUser